import { render } from "./CommonErrorNotification.vue?vue&type=template&id=6ddcd8b8"
import script from "./CommonErrorNotification.vue?vue&type=script&lang=js"
export * from "./CommonErrorNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__